import React from 'react';
import { FlexColumnCentered } from '../../../../../components/ui/Content';
import { useTranslation } from 'react-i18next';
import { RegFormTitle } from '../styles';

const FormTitle = () => {
	const { t } = useTranslation();

	return (
		<FlexColumnCentered>
			<RegFormTitle>{t('passport.registrationForm.title')}</RegFormTitle>
		</FlexColumnCentered>
	);
};

export default FormTitle;
